import { __assign, __read, __spreadArray, __values } from "tslib";
import { ContentActionItemType, } from '@office-start/document-types';
var getDivider = function (dividerId, dividerText) {
    if (dividerText === void 0) { dividerText = ''; }
    return {
        id: dividerId,
        title: dividerText,
        ariaLabel: dividerText,
        contentActionOptions: {
            itemType: ContentActionItemType.Divider,
        },
    };
};
var addActionsWithDivider = function (documentActions, heroActions, dividerId, dividerText) {
    if (dividerText === void 0) { dividerText = ''; }
    if (Array.isArray(heroActions)) {
        documentActions.push.apply(documentActions, __spreadArray([getDivider(dividerId, dividerText)], __read(heroActions), false));
    }
    else {
        documentActions.push(getDivider(dividerId, dividerText), heroActions);
    }
};
var maybeAddGroupResultTypeToList = function (groupResultTypeDocumentActions, result) {
    if (groupResultTypeDocumentActions.length > 0) {
        result.push.apply(result, __spreadArray([], __read(groupResultTypeDocumentActions), false));
    }
};
export var maybeAddGroupWithSubMenus = function (allDocumentActionGroups, groupInfo, groupKey, groupedDocumentActions) {
    if (allDocumentActionGroups[groupKey].length === 0) {
        return;
    }
    var selectedGroup = groupInfo[groupKey];
    groupedDocumentActions.push({
        ariaLabel: selectedGroup.ariaLabel,
        id: selectedGroup.id,
        title: selectedGroup.title,
        contentActionOptions: {
            icon: selectedGroup.icon,
        },
        subMenus: allDocumentActionGroups[groupKey],
    });
};
export var groupDocumentActions = function (documentActions, groupInfo) {
    var e_1, _a;
    var _b;
    // No groups? Send it flat 🫓
    if (!groupInfo) {
        return documentActions;
    }
    // Group existing document actions 🔗
    var allDocumentActionGroups = {
        AddTo: [],
        MosApp: [],
        None: [],
        Open: [],
        OpenHero: [],
        OpenMenu: [],
        Hero: [],
        Share: [],
        Unknown: [],
    };
    try {
        for (var documentActions_1 = __values(documentActions), documentActions_1_1 = documentActions_1.next(); !documentActions_1_1.done; documentActions_1_1 = documentActions_1.next()) {
            var action = documentActions_1_1.value;
            allDocumentActionGroups[((_b = action.contentActionOptions) === null || _b === void 0 ? void 0 : _b.groupId) || 'Unknown'].push(action);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (documentActions_1_1 && !documentActions_1_1.done && (_a = documentActions_1.return)) _a.call(documentActions_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    // Build up menu based on the grouping...🍔
    var groupedDocumentActions = [];
    // Open is a little special because of the split button and hero logic...
    // Open | > [ Browser/Desktop | File Location ]
    if (allDocumentActionGroups.OpenMenu.length === 1) {
        // Get the open split button and set the subMenus to all 'Open' actions
        var openMenu = allDocumentActionGroups.OpenMenu[0];
        var subMenus = __spreadArray([], __read(allDocumentActionGroups.Open), false);
        // If there's an open hero action, add in a divider and the hero action at the bottom (like 'File Location' above)
        if (allDocumentActionGroups.OpenHero.length === 1) {
            if (subMenus.length > 0) {
                addActionsWithDivider(subMenus, allDocumentActionGroups.OpenHero[0], 'openHeroDivider');
            }
            else {
                subMenus.push(allDocumentActionGroups.OpenHero[0]);
            }
        }
        // Make it a split button if we have any other 'Open' actions, otherwise, make it a normal button
        var hasSubMenus = subMenus.length > 0;
        openMenu.contentActionOptions = __assign(__assign({}, openMenu.contentActionOptions), { split: hasSubMenus });
        // Only set subMenus when length > 0, otherwise, an empty menu will be rendered 😔
        openMenu.subMenus = hasSubMenus ? subMenus : undefined;
        groupedDocumentActions.push(openMenu);
    }
    // Share
    maybeAddGroupWithSubMenus(allDocumentActionGroups, groupInfo, 'Share', groupedDocumentActions);
    // Add divider if there is something to divide
    if (groupedDocumentActions.length > 0) {
        groupedDocumentActions.push(getDivider('openShareDivider'));
    }
    // Add To
    maybeAddGroupWithSubMenus(allDocumentActionGroups, groupInfo, 'AddTo', groupedDocumentActions);
    // Unknown - Add in unknown actions before we insert registered/known top-level or hero actions
    maybeAddGroupResultTypeToList(allDocumentActionGroups.Unknown, groupedDocumentActions);
    // None - Add all top-level items
    maybeAddGroupResultTypeToList(allDocumentActionGroups.None, groupedDocumentActions);
    // MosApp - add actions supported by MOS apps.
    // Note: not all mos app actions will be added into this bucket. Depending on action 'intent' defined in app manifest, action could be added to other groups. Details in mosAppActionUtils.
    // TODO: might use maybeAddGroupWithSubMenus when design finalized
    if (allDocumentActionGroups.MosApp.length > 0) {
        addActionsWithDivider(groupedDocumentActions, allDocumentActionGroups.MosApp, 'mosAppDivider');
    }
    // Hero - Is there a hero action?
    if (allDocumentActionGroups.Hero.length === 1) {
        addActionsWithDivider(groupedDocumentActions, allDocumentActionGroups.Hero[0], 'heroDivider');
    }
    return groupedDocumentActions;
};
//# sourceMappingURL=groupActions.js.map